import React from 'react'
import { FormikProps } from 'formik'
import { toast } from 'react-toastify'
import { useMerchantE } from 'lib/core/hooks'
import { Failure } from 'lib/ui/components/Toast/components/Failure'
import { getCreditCardCode } from 'lib/core/resources/helpers'
import {
  useCheckout,
  usePaymentMethod,
  CreditCardForm,
  CreditCardData,
  CreditCardFormValues
} from 'lib/modules/checkout'

import { Container } from './styled'

let formik: FormikProps<CreditCardFormValues>
let values: CreditCardData

const showToastError = (errorMessage: string) => {
  toast(() => (
    <Failure
      message={errorMessage}
    />
  ), {
    autoClose: 15000
  })
}

export const MerchantE = () => {
  const { authorizeCard, setPaymentMethodOnCart } = useMerchantE()
  const { placeOrder } = useCheckout()

  usePaymentMethod(() => {
    const performPlaceOrder = async () => {
      try {
        const errors = await formik.validateForm()
        const hasErrors = Boolean(Object.keys(errors).length)
        const [card] = values.cardType

        if (!hasErrors) {
          const token: string = await authorizeCard({
            creditCardData: {
              expMonth: values.expMonth,
              expYear: values.expYear,
              number: values.number
            }
          })
          await setPaymentMethodOnCart({ token, last4: values.number.slice(-4), ccType: getCreditCardCode(card.type), cvv: values.cvv, saveCard: values.saveCreditCard ?? false })
          placeOrder()
        }
      } catch (error) {
        showToastError(error.toString())
      }
    }
    formik.handleSubmit()
    performPlaceOrder()
  })

  function handleChange (formValues: CreditCardData, formikObject: FormikProps<CreditCardFormValues>) {
    formik = formikObject
    values = formValues
  }

  return (
    <Container>
      <CreditCardForm
        onChange={handleChange}
        allowSaveCreditCard
      />
    </Container>
  )
}
